import { useState } from "react"
import { useSelector } from "react-redux"
import styled from "styled-components"
import AracDetails from "../../sections/yukDetails/AracDetails"
import RouteDetails from "../../sections/yukDetails/RouteDetails"
import YukDetails from "../../sections/yukDetails/YukDetails"
import OdemeDetails from "../../sections/yukDetails/OdemeDetails"
import Button from "../../../shared/Button"
import { useDispatch } from "react-redux"
import { showModal } from "../../../../features/modal/modalSlice"
import { setErrors } from "../../../../features/addLoad/addLoadSlice"
import submitLoadPermission from "../../../../helper/load/submitLoadPermission"
import { setLoadItemData } from "../../../../features/loadList/loadListSlice"
import RoutesMapSection from "../../mainSections/RoutesMapSection"


const Container = styled.div`
    width: 500px;
    position: relative;
    

    .wrapper{
        width: 500px;

        position: ${({yukKayit}) => yukKayit ? "sticky" : "fixed" } ;
        right: 35px;
        bottom: 0;
        /* top: 280px; */
        top: ${({yukKayit}) => yukKayit ? "0" : "280px" } ;
        .map-side-content{
          padding: 5px 30px 20px 30px;
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          border-radius: 10px;
          background-color: ${({theme}) => theme.secondaryBgColor} !important;
          height: max-content;

        }

        .top{
          padding: 8px 0;

          h3{
            font-size: var(--font-size-md);
            font-weight: var(--font-weight-lg);
            color: ${({theme}) => theme.mainTextColor};
          }
        }

        .map-container{
          width: 100%;
          height: 200px;
          border-radius: 10px;
        }

        .details-container{
          width: 100%;
          display: flex;
          flex-direction: column;
          overflow: auto;
          gap: 10px;
          padding-top: 10px;
          height: calc(100vh - 610px);

          &::-webkit-scrollbar {
            width: 5px;
          }
          &::-webkit-scrollbar-thumb {
              background-color: #9e9b9b;
              border-radius: 10px;
          }
          &::-webkit-scrollbar-track {
              background-color: transparent;
          }
        }
    }

    @media (max-width: 1200px){
        width: 450px !important;
        .wrapper{
          width: 450px !important;
        }
    }
`

const MapSide = ({yukKayit}) => {

  const dispatch = useDispatch()

  const {
    route,
    aracData,
    paymentData,
    yukData,
    paketlemeData,
    routeDistance,
    selectedProjectAddLoad
  } = useSelector((state) => state.addLoad);
  
  const handleClick = () => {
    //! buradan true gelirse iyi false gelirse error verilmeli
    if(submitLoadPermission(route, aracData, paymentData, yukData, paketlemeData, routeDistance, selectedProjectAddLoad)){
      // dispatch(showModal("addLoadYuklemeSecenekleri"))
      dispatch(showModal("addLoadYetkiliBilgiForm"))
      
      dispatch(setLoadItemData(route))
      // localStorage.removeItem("routeData");
      // dispatch(resetAddLoadState())
    }
    else{
      dispatch(setErrors(true))
      dispatch(showModal("loadPermissionError"))
    }

  }



  return (
    <Container yukKayit={yukKayit}>
        <div className="wrapper">
          <div className="map-side-content">
          <div className="top" onClick={() => dispatch(showModal("addLoadMapWide"))}>
          {/* <div className="top"> */}
                <h3>Yüke İlişkin Detaylar</h3>
          </div>
          <div className="map-container">
            {/* <GivenMapSection route={routeList} defaultLocation={{lat: 38.75, lng: 33.75}} zoom={5}/> */}
            <RoutesMapSection
              from={"add"}
              route={route.map(item => {
              return {
                lat: parseFloat(item.locationData.lat.toString().replace(",", ".")),
                lng: parseFloat(item.locationData.lng.toString().replace(",", "."))
              }
            })} defaultLocation={{lat: 38.75, lng: 33.75}} zoom={5}/>
          </div>
          <div className="details-container">
            <RouteDetails route={route} routeDistance={routeDistance}/>
            <AracDetails aracData={aracData}/>
            <YukDetails yukData={yukData} paketlemeData={paketlemeData}/>
            <OdemeDetails odemeData={paymentData}/>
          </div>
          {!yukKayit && <Button color={"#F4F4F4"} background={"#E85446"} width="100%" radius={"10px"} text={"Tamamla"} fontSize="14px" handleClick={handleClick}/>}
            </div>
          </div>

    </Container>
  )
}

export default MapSide